import CandidateManagerContainer from "../../container/admin/candidate-manager";

const CandidateManager = () => {
    return <CandidateManagerContainer />;
};

export default CandidateManager;